module.exports = __webpack_public_path__ + "static/media/boat-img-41.fa925863.jpg";